import Awards from 'molecules/Awards';
import Heading, { hasHeading } from 'molecules/Heading';
import Section from 'molecules/Section';
import { splitSectionProps } from 'molecules/Section/config';

import type { AwardsConfigProps } from 'components/Awards/config';
import type { FC } from 'react';

const AwardsComponent: FC<AwardsConfigProps> = ({ awardItems, ...props }) => {
  const { sectionProps, rest } = splitSectionProps(props);

  return (
    <Section noContain {...sectionProps}>
      <div className="flex flex-col justify-center gap-10 sm:gap-14 lg:gap-16">
        {hasHeading(rest) && <Heading {...rest} />}
        <Awards awardItems={awardItems} />
      </div>
    </Section>
  );
};

export default AwardsComponent;
